import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import translationENG from './locales/en/translation.json';
import translationVi from './locales/vi/translation.json';

//translations
const resources = {
  en: {
    translation: translationENG,
  },
  vi: {
    translation: translationVi,
  },
};

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
